import Vue from 'vue'
const Hub = new Vue()

/**
 * The Event Hub: a Vue instance that just does events
 * Pre-Processing Redemption Events
 *  - redemption-method-called: emitted when redemptionIntent is called, passes the redemption method along as a param
 *    (ex. scan or stamp)
 *  - redemption-validation-code-input-success: emitted when the code input method has tried to get the code. The param passed
 *    back is in json with a success boolean, method, intent and result
 *  - redemption-validation-code-input-fail: emitted when the code input method has tried to get the code. The param passed
 *    back is in json with a success boolean, method, intent and result
 * Post-Processing Voucher Redemption Events
 *  - post-voucher-redemption-response-success: emitted when api responds with redemption information
 *  - post-voucher-redemption-response-fail: emitted when api responds with redemption fail
 * Post-Processing Loyalty Earn Event
 *  - post-loyalty-earn-response-success
 *  - post-loyalty-earn-response-fail
 * Post-Processing Loyalty Redeem Event
 *  - post-loyalty-redeem-response-success
 *  - post-loyalty-redeem-response-fail
 * Location Updates
 *  - location-changed
 */

export default Hub



// WEBPACK FOOTER //
// ./src/events/Hub.js